import {useQuery} from "@tanstack/react-query";
import {readNewProductGroup} from "../../../../../api/main/SalesApi";

interface Props {
    enabled: boolean
}

export const useReadNewProductGroup = ({enabled}: Props) => {
    const {data} = useQuery({
        queryKey: ["readNewProductGroup"],
        queryFn: async () => await readNewProductGroup(),
        select: (res) => res?.data.result.newProductGroupVOList ?? {newProductGroupVOList: []},
        enabled: enabled
    });

    return {data};
};
